// extracted by mini-css-extract-plugin
module.exports = {"thankYouDiv":"ThankYou_thankYouDiv__3Rsj4","title":"ThankYou_title__2FUMb","subtitle":"ThankYou_subtitle__2HEVC","closeButton":"ThankYou_closeButton__3vmfx"};